import axios from 'axios'

var API_URL = process.env.VUE_APP_URL + '/api/carousel/'
class ConfigService {
    getCarousel() {
        return axios.get(API_URL)
    }
    putCarousel(car) {
        return axios.put(API_URL, car)
    }
    getFotos(num) {
        return axios.get(API_URL + 'fotos?n=' + num, {
          responseType: 'arraybuffer'
        })
    }

    postImagen(idcar, formData) {
      return axios.post(API_URL + 'imagen' + '?idcar=' + idcar , formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    }
    postVideo(idcar, formData) {
      return axios.post(API_URL + 'video' + '?idcar=' + idcar , formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    }
}

export default new ConfigService()